import { BitrixVue } from "ui.vue3";
import { AlertVueComponent } from "nanocad-ui.nano-alert";
import { CommercialLicenseWidget } from "./components/CommercialLicenseWidget/CommercialLicenseWidget";
import { store } from "./store/global.store";

export class HomePageAvailableCommercialLicenseWidget {
  #application;
  /**
   *
   * @param {HTMLElement|string} rootNode
   * @param {Object} options
   * @param {Object} options.request
   * @param {String} options.request.component - Название компонента
   * @param {String} options.request.action - Название экшена
   */
  constructor(rootNode, options = {}) {
    this.rootNode =
      rootNode instanceof HTMLElement
        ? rootNode
        : document.querySelector(rootNode);
    this.options = options;
    this.attachTemplate();
  }
  attachTemplate() {
    const context = this;
    store.dispatch("setGlobalParams", context.options);

    this.#application = BitrixVue.createApp({
      name: "HomePageAvailableCommercialLicenseWidgetApp",
      beforeCreate() {
        this.$bitrix.Application.set(context);
      },
      components: {
        CommercialLicenseWidget,
      },
      template: `<CommercialLicenseWidget/>`,
    });
    this.#application.use(store);
    this.#application.component("Alert", AlertVueComponent);
    this.#application.mount(this.rootNode);
  }
}
